import React, {
  useState,
  useEffect,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import axios from "axios";
import { toast } from "react-toastify";
import useAppContext, { actions } from "../../../utils/Reducers";

import { useAxiosWithAuthorization } from "../../../utils/api";
import { ModalIncomeCallPop } from "../popup/IncomeCallPop";
import { ModalImagePop } from "../popup/ImagePop";

const Incoming = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    async onSearch(items) {
      await handleMasterSearch(items);
    },
  }));

  const [searchData, setSearchData] = useState([]);

  const [callCount, setCallCount] = useState({
    statusA: "",
    statusG: "",
  });

  const {
    store: { userInfo },
  } = useAppContext();


  const SEARCH_INCOMING_VEHICLE_LIST_URL =
    // "/mobileweb/incoming/sp_search_incoming_vehicle_list.do";
    "/mobileweb/incoming/SP_SEARCH_INCOMING_VEHICLE_LIST.do";

  //도착보고-입차호출 카운트 호출
  const SEARCH_INCOMING_VEHICLE_COUNT_URL =
    "/mobileweb/incoming/SP_SEARCH_INCOMING_VEHICLE_COUNT.do";

  //배차정보 저장 URL
  const CHANGE_TRANSO_STATUS_URL = "/mobileweb/incoming/changeTransStatus.do";

  //배차정보 저장 URL
  //const MESSAGE_TRANSORDER_URL = "http://tms.idaehan.com:8080/message/sendTransCallInMessage.do";
  const MESSAGE_TRANSORDER_URL =
    "https://tms.idaehan.com:8443/message/sendTransCallInMessage.do";

  //배차취소 URL
  const MESSAGE_CALLCANCEL_URL =
    "https://tms.idaehan.com:8443/message/sendTransCallCancelMessage.do";
  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SEARCH_INCOMING_VEHICLE_LIST_URL,
    },
    { manual: true }
  );

  //메시지 전송을 하고 나서 배송상태값을 입차호출 T 로 변경
  const onIncomingClick = useCallback(async (data) => {
    if (window.confirm(data.drivTel + "님에게 입차호출 하겠습니까?")) {
      //console.log(data.plantCd);
      onIncomeCallIn(data);
    }
  });

  const onIncomeCallIn = (data) => {
    ModalIncomeCallPop({
      title: "입차호출",
      data: data,
      onSelectPlant: onSelectPlant,
    });
  };

  //팝업 데이터 가져오기
  const onSelectPlant = useCallback(async (values) => {
    var transStatusCd = "";
    if (values.transStatusCd !== "N") {
      transStatusCd = "G";
    } else {
      transStatusCd = "I";
    }

    const {
      data: { statusCode },
    } = await axios({
      method: "POST",
      url: MESSAGE_TRANSORDER_URL,
      data: {
        tmsOdrNo: values.tmsOdrNo,
        systemCd: values.systemCd,
        vhclNo: values.vhclNo,
        drivTel: values.drivTel,
        transStatusCd: transStatusCd,
      },
    }).catch(function (error) {
      if (error.response) {
        // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
        //console.log(error.response.data);
        //console.log(error.response.status);
        //console.log(error.response.headers);
        toast.error(
          "카카오톡 전송 오류 : " + error.response.data.error.message
        );
      } else if (error.request) {
        // 요청이 이루어 졌으나 응답을 받지 못했습니다.
        // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
        // Node.js의 http.ClientRequest 인스턴스입니다.
        //console.log(error.request);
      } else {
        // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
        //console.log("Error", error.message);
      }
      //console.log(error.config);
    });

    if (statusCode === "200") {
      const {
        data: { data },
      } = await fetchData({
        url: CHANGE_TRANSO_STATUS_URL,
        data: {
          systemCd: values.systemCd,
          scrapAreaCd: values.scrapAreaCd,
          tmsOdrNo: values.tmsOdrNo,
          transStatusCd: transStatusCd,
        },
        method: "POST",
      });
    } else {
      alert("입차호출 에러로 다시 입차호출버튼을 클릭해주시기 바랍니다.  ");
    }

    handleMasterSearch(props.searchParameters);
  });

  const onIncomingCancleClick = async (data) => {
    if (window.confirm(data.drivTel + "님에게 입차호출 취소하겠습니까?")) {
      const {
        data: { statusCode },
      } = await axios({
        method: "POST",
        url: MESSAGE_CALLCANCEL_URL,
        data: {
          tmsOdrNo: data.tmsOdrNo,
          systemCd: data.systemCd,
          vhclNo: data.vhclNo,
          drivTel: data.drivTel,
          transStatusCd: "B",
        },
      }).catch(function (error) {
        if (error.response) {
          // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
          //console.log(error.response.data);
          //console.log(error.response.status);
          //console.log(error.response.headers);
          toast.error(
            "카카오톡 전송 오류 : " + error.response.data.error.message
          );
        } else if (error.request) {
          // 요청이 이루어 졌으나 응답을 받지 못했습니다.
          // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
          // Node.js의 http.ClientRequest 인스턴스입니다.
          //console.log(error.request);
        } else {
          // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
          //console.log("Error", error.message);
        }
        //console.log(error.config);
      });

      console.log(statusCode);
      if (statusCode === "200") {
        const response = await fetchData({
          url: CHANGE_TRANSO_STATUS_URL,
          data: {
            systemCd: data.systemCd,
            scrapAreaCd: data.scrapAreaCd,
            tmsOdrNo: data.tmsOdrNo,
            transStatusCd: "A",
          },
          method: "POST",
        });
        handleMasterSearch(props.searchParameters);
      }
    }
  };

  useEffect(async () => {
    handleMasterSearch(props.searchParameters);
  }, []);

  const handleMasterSearch = async (items) => {
    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_INCOMING_VEHICLE_LIST_URL,
      params: items,
    });
    //console.log(data);
    setSearchData(data);

    const count = await fetchData({
      url: SEARCH_INCOMING_VEHICLE_COUNT_URL,
      params: items,
    });
    //console.log(count.data.data[0]);

    setCallCount(count.data.data[0]);
  };

  const onImageViewClick = (data) => {
    ModalImagePop({
      title: "사진",
      tmsOdrNo: data.tmsOdrNo,
    });
  };

  return (
    <>
      <div id="menu1" className="list">
        {searchData &&
          searchData?.map((data, index) => {
            return (
              <div key={index}>
                <div className="ctitle">
                  <h1 className="carno">{data.vhclNo}</h1>
                  <div>
                    {data.warmCnt > 0 ? <button className="al"></button> : ""}
                    {data.outageWght > 0 ? (
                      <div className="nums">-{data.outageWght}</div>
                    ) : (
                      ""
                    )}
                    {data.returnCnt > 0 ? (
                      <button className="close"></button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="ctitle">
                  <h2>
                    {data.itemNm}
                    {data.itemEtcRmksNm !== " " ? "/" + data.itemEtcRmksNm : ""}
                    {data.inspRmks !== " " ? "(" + data.inspRmks + ")" : ""}
                  </h2>
                  <div>
                    <div className="stat ready">배차</div>
                    <div className="no">
                      <h2 className="ready">{data.tmsOdrNo}</h2>
                    </div>
                  </div>
                </div>
                <div className="cinfo">
                  <div>
                    <h2>
                      {props.bmenuTab === "scrap"
                        ? data.loadAreaAddr
                        : data.shipNm}
                    </h2>
                  </div>
                  <div className="phone">
                    <h2>{data.drivTel}</h2>
                  </div>
                  <div>
                    <div className="stat arrive">도착</div>
                    <div>
                      <h2 className="date arrive" style={{ marginLeft: "0" }}>
                        {data.arrvDt}
                      </h2>
                    </div>
                  </div>
                  <div className="com">
                    <h2>
                      {data.vndrNm} / {data.rvndrNm}
                    </h2>
                  </div>
                </div>
                <div className="btns">
                  <div>
                    <button
                      className="active"
                      onClick={(event) => onImageViewClick(data)}
                    >
                      사진
                    </button>
                  </div>
                  <div>
                    <button
                      className={data.transStatusCd === "G" ? "active" : ""}
                      onClick={
                        data.transStatusCd === "G"
                          ? (event) => onIncomingCancleClick(data)
                          : ""
                      }
                    >
                      호출취소
                    </button>
                    <button
                      className={data.transStatusCd === "A" ? "active" : ""}
                      onClick={
                        data.transStatusCd === "A"
                          ? (event) => onIncomingClick(data)
                          : ""
                      }
                    >
                      입차호출
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        {searchData?.length > 0 ? (
          <p>* 호출취소 : 실행 전 배차상태 확인</p>
        ) : (
          ""
        )}
      </div>
      {searchData?.length > 0 ? (
        <div className="res">
          <div>
            <div>도착보고</div>
            <div className="val">
              <div>{callCount.statusA}</div>
            </div>
          </div>
          <div>
            <div>입차호출</div>
            <div className="val">
              <div>{callCount.statusG}</div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
});

export default Incoming;
